export enum LanguageCode {
  AR = 'ar',
  DA = 'da',
  DE = 'de',
  EN = 'en',
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  ES = 'es',
  FR = 'fr',
  ID = 'id',
  IT = 'it',
  JA = 'ja',
  KO = 'ko',
  MS = 'ms',
  // `nb` is Norwegian Bokmål, the specific written standard. Used by Automations v3, whose BE keys Norwegian content by `nb`/`nb_NO`.
  NB = 'nb',
  NL = 'nl',
  // `no` is the macro language "Norwegian" (umbrella over Bokmål `nb` and Nynorsk `nn`). Used by Property Descriptions (`no`/`no_NO`). Keep `nb` and `no` separate: they map to different BE locale codes and are not interchangeable across features.
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  RU = 'ru',
  TR = 'tr',
  VI = 'vi',
  ZH = 'zh',
  ZH_TW = 'zh_TW',
}

export enum LanguageCodeUnderscored {
  AR_SA = 'ar_SA',
  DE_DE = 'de_DE',
  EN_US = 'en_US',
  ES_ES = 'es_ES',
  FR_FR = 'fr_FR',
  IT_IT = 'it_IT',
  JA_JP = 'ja_JP',
  KO_KR = 'ko_KR',
  NL_NL = 'nl_NL',
  NO_NO = 'no_NO',
  PL_PL = 'pl_PL',
  PT_PT = 'pt_PT',
  RU_RU = 'ru_RU',
  TR_TR = 'tr_TR',
  VI_VN = 'vi_VN',
  ZH_CN = 'zh_CN',
}
